if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      this.autoSlideInterval = 3000; // Set the auto-slide interval (3 seconds)
      this.autoSlideTimer = null; // Store the auto-slide timer

      this.init();
    }

    init() {
      this.updateNavButtons();

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.resetAutoSlide(); // Reset auto-slide timer on manual navigation
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.resetAutoSlide(); // Reset auto-slide timer on manual navigation
        });
      }

      // Start auto-sliding
      this.startAutoSlide();
    }

    changeSlide(direction) {
      this.index = direction === 'next' ? this.index + 1 : this.index - 1;

      // Loop back to start or end if needed
      if (this.index >= this.length) {
        this.index = 0;
      } else if (this.index < 0) {
        this.index = this.length - 1;
      }

      this.updateNavButtons();

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    updateNavButtons() {
      if (this.nextButton) {
        this.nextButton.classList.toggle('announcement-bar__content-nav--disabled', this.index === this.length - 1);
      }
      if (this.prevButton) {
        this.prevButton.classList.toggle('announcement-bar__content-nav--disabled', this.index === 0);
      }
    }

    startAutoSlide() {
      this.autoSlideTimer = setInterval(() => {
        this.changeSlide('next');
      }, this.autoSlideInterval);
    }

    resetAutoSlide() {
      clearInterval(this.autoSlideTimer);
      this.startAutoSlide();
    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
